module.exports = __webpack_public_path__ + "cd9491e086c2bb0e802602020490e70f.MP3";